module.exports = __webpack_public_path__ + "img/RegFees-OD-FAQ.6fed2b3a.svg";